/* think27 · WhatsApp session hand-off v2 — visitor journey (DZYN, 27-Sep-2026)
   Contracts: _project-website-bythink27/wa-session/CRM-HANDOFF.md (v1 /session) + CRM-HANDOFF-v2-ACTIVITY.md (v2 /activity).
   1. A permanent visitor id (cookie t27_vid + localStorage t27ws.v2; each restores the other) and the full history of
      this browser: up to 30 visits / 300 pages — source, landing, pages + time + scroll, products, searches, cart, checkout.
   2. On a click on ANY WhatsApp link: a fresh 5-char ref code written INVISIBLY (2 copies) into the prefilled message,
      the link rebuilt as api.whatsapp.com/send, and the session + whole history posted to /session (schema v1 + `history`).
   3. From that first tap the browser is "enabled": its activity is posted in batches to /activity (dzyn.wa_activity.v1),
      about every 10 s and on page leave. Consent declined → minimal (no journey, no activity). Automated browsers → none.
   Config comes from snippets/think27-wa-session.liquid (window.__T27WA). Encoder = the shared v1 scheme in
   _project-website-bythink27/wa-session/wa-code.js — keep BOTH in step. */
(function () {
  'use strict';
  var CFG = window.__T27WA;
  if (!CFG || !CFG.enabled || window.__t27wsBooted) return;
  window.__t27wsBooted = true;

  /* ---------------- shared v1 invisible code (identical to wa-code.js) ---------------- */
  var ALPHA = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
  var SYM = ['‌', '⁠', '⁢', '⁣'];
  var FRAME = '⁤';
  function crc7(bytes) {
    var crc = 0;
    for (var k = 0; k < bytes.length; k++) {
      var b = bytes[k];
      for (var i = 7; i >= 0; i--) {
        var bit = ((b >> i) & 1) ^ ((crc >> 6) & 1);
        crc = (crc << 1) & 0x7f;
        if (bit) crc ^= 0x09;
      }
    }
    return crc;
  }
  function codeToValue(code) { var v = 0; for (var i = 0; i < 5; i++) v = v * 32 + ALPHA.indexOf(code[i]); return v; }
  function valueBytes(v) { return [(v >>> 24) & 0xff, (v >>> 16) & 0xff, (v >>> 8) & 0xff, v & 0xff]; }
  function encode(code) {
    var v = codeToValue(code), p = v * 128 + crc7(valueBytes(v)), out = '';
    for (var i = 15; i >= 0; i--) out += SYM[Math.floor(p / Math.pow(4, i)) % 4];
    return FRAME + out + FRAME;
  }
  function strip(t) { return (t || '').replace(/[‌⁠⁢⁣⁤]/g, ''); }
  function embed(text, code) {
    var inv = encode(code), clean = strip(text), spans = [], u;
    var ure = /(https?:\/\/|www\.|[a-z0-9-]+\.(com|in|cloud|co)\b)\S*/gi;
    while ((u = ure.exec(clean))) spans.push([u.index, u.index + u[0].length]);
    function inUrl(i) { for (var s = 0; s < spans.length; s++) if (i >= spans[s][0] && i <= spans[s][1]) return true; return false; }
    var spots = [];
    for (var i = 1; i < clean.length - 1; i++) {
      if (/[A-Za-z]/.test(clean[i - 1]) && (clean[i] === ' ' || clean[i] === ',') && !inUrl(i)) spots.push(i);
    }
    if (!spots.length) {
      var w = /^[A-Za-z]{2,}/.exec(clean), at = w ? Math.min(2, w[0].length - 1) : clean.length;
      return clean.slice(0, at) + inv + clean.slice(at);
    }
    var a = spots[0], target = Math.floor(clean.length * 0.6), b = spots[spots.length - 1];
    for (var j = 0; j < spots.length; j++) if (Math.abs(spots[j] - target) < Math.abs(b - target)) b = spots[j];
    if (b === a) b = spots.length > 1 ? spots[spots.length - 1] : -1;
    var pts = [a, b].filter(function (x) { return x > 0; }).sort(function (x, y) { return y - x; }), out = clean;
    for (var q = 0; q < pts.length; q++) out = out.slice(0, pts[q]) + inv + out.slice(pts[q]);
    return out;
  }
  function randomCode() {
    var buf = new Uint8Array(5), s = '';
    (window.crypto || window.msCrypto).getRandomValues(buf);
    for (var i = 0; i < 5; i++) s += ALPHA[buf[i] % 32];
    return s;
  }

  /* ======================= v2 (YR 27-Sep "Website ↔ WhatsApp Journey" §6) =======================
     1 permanent visitor id (cookie + localStorage, each restores the other) · 2 full history in the browser (≤30 visits /
     300 pages) · 3 a WhatsApp tap sends the WHOLE history (same /session door, extra `history` field) · 4 the browser is
     "enabled" after its first tap · 5 enabled browsers post activity batches to /activity (schema dzyn.wa_activity.v1),
     ~10 s and on page leave, retried with back-off, deduped by batch id · 6 consent-minimal and automated browsers
     respected. Contract: _project-website-bythink27/wa-session/CRM-HANDOFF-v2-ACTIVITY.md. */
  var KEY = 't27ws.v2', OLDKEY = 't27ws.v1', PKEY = 't27ws.pending.v1', AKEY = 't27ws.actq.v1', CK = 't27_vid';
  var SESSION_GAP = 30 * 60 * 1000, MAX_VISITS = 30, MAX_PAGES_TOTAL = 300, MAX_PAGES_VISIT = 60;
  var ACT_EVERY = 10000, ACT_MAX_EVENTS = 60;
  function nowIso() { return new Date().toISOString(); }
  function load(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage full/blocked: state stays in memory */ } }
  function rid(p) { var b = new Uint8Array(8); (window.crypto || window.msCrypto).getRandomValues(b); return p + Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); }
  function readCookie() { var m = document.cookie.match(/(?:^|;\s*)t27_vid=(v_[0-9a-f]{16})/); return m ? m[1] : ''; }
  function writeCookie(v) {                                   // first-party, ~13 months (Chrome caps cookies at 400 days)
    try { document.cookie = CK + '=' + v + '; Max-Age=34560000; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (e) {}
  }
  var AUTOMATED = !!navigator.webdriver && !CFG.allow_automated;

  function consentMode() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false) return 'minimal';
    } catch (e) {}
    return 'full';
  }

  var params = new URLSearchParams(location.search);
  function sourceOf(ref, utm, ids) {
    if (utm.source) return { source: utm.source, medium: utm.medium || '' };
    if (ids.gclid || ids.gbraid || ids.wbraid) return { source: 'google', medium: 'cpc' };
    if (ids.fbclid) return { source: 'facebook', medium: 'paid_or_social' };
    if (ids.msclkid) return { source: 'bing', medium: 'cpc' };
    if (!ref) return { source: '(direct)', medium: '(none)' };
    var h = '';
    try { h = new URL(ref).hostname.replace(/^www\./, ''); } catch (e) {}
    if (/(^|\.)dzynfurnitures\.com$|myshopify\.com$/.test(h)) return { source: '(internal)', medium: '(none)' };
    if (/google\./.test(h)) return { source: 'google', medium: 'organic' };
    if (/bing\.|duckduckgo\.|yahoo\./.test(h)) return { source: h.split('.')[0], medium: 'organic' };
    if (/instagram|facebook|fb\.|t\.co|twitter|x\.com|youtube|pinterest|linkedin|whatsapp/.test(h)) return { source: h, medium: 'social' };
    return { source: h, medium: 'referral' };
  }
  function landingNow() {
    var utm = {}, ids = {};
    ['source', 'medium', 'campaign', 'term', 'content'].forEach(function (k) { utm[k] = params.get('utm_' + k) || ''; });
    ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid'].forEach(function (k) { ids[k] = params.get(k) || ''; });
    var ref = document.referrer || '', s = sourceOf(ref, utm, ids);
    return { at: nowIso(), url: location.href, referrer: ref, source: s.source, medium: s.medium, utm: utm, click_ids: ids };
  }
  function newVisit(t) {
    return { sid: rid('s_'), started: nowIso(), last_active: t, landing: landingNow(), campaign_key: '', pages: [], pages_count: 0,
      products: {}, collections: {}, searches: [], add_events: [], cart_events: [], checkout_started_at: null, wa_clicks: [],
      variant_changes: [], media_opens: [], delivery_checks: [], checkout_steps: [] };
  }

  /* ---------- state (v2) — migrates the v1 record once ---------- */
  var t = Date.now();
  var st = load(KEY);
  if (!st || st.v !== 2) {
    var o = load(OLDKEY);
    st = { v: 2, vid: (o && o.vid) || '', first_seen: (o && o.first_seen) || nowIso(), visit_no: (o && o.visits) || 0,
      first_touch: (o && o.first_touch) || null, enabled_at: null, codes: [], visits: [] };
    if (o && o.sid) {
      st.visits.push({ sid: o.sid, started: o.started, last_active: o.last_active, landing: o.landing, campaign_key: o.campaign_key || '',
        pages: o.journey || [], pages_count: o.pages_count || (o.journey || []).length, products: o.products || {}, collections: o.collections || {},
        searches: o.searches || [], add_events: o.add_events || [], cart_events: [], checkout_started_at: o.checkout_started_at || null,
        wa_clicks: o.wa_clicks || [] });
      (o.wa_clicks || []).forEach(function (w) { if (w.code && st.codes.indexOf(w.code) < 0) st.codes.push(w.code); });
      if (st.codes.length) st.enabled_at = (o.wa_clicks[0] && o.wa_clicks[0].at) || nowIso();
    }
  }
  // 1. the permanent visitor id: cookie and localStorage restore each other
  var ck = readCookie();
  if (!st.vid && ck) st.vid = ck;
  if (!st.vid) st.vid = rid('v_');
  if (ck !== st.vid) writeCookie(st.vid);

  var cur = st.visits[st.visits.length - 1];
  var campaignKey = ['utm_source', 'utm_campaign', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid'].map(function (k) { return params.get(k) || ''; }).join('|');
  var newCampaign = campaignKey.replace(/[|]/g, '') !== '' && (!cur || campaignKey !== cur.campaign_key);
  var startedVisit = false;
  if (!cur || !cur.last_active || t - cur.last_active > SESSION_GAP || newCampaign) {
    cur = newVisit(t); cur.campaign_key = campaignKey;
    st.visits.push(cur); st.visit_no = (st.visit_no || 0) + 1; startedVisit = true;
    if (!st.first_touch) st.first_touch = cur.landing;
  }
  ['pages', 'searches', 'add_events', 'cart_events', 'wa_clicks', 'variant_changes', 'media_opens', 'delivery_checks', 'checkout_steps'].forEach(function (k) { if (!Array.isArray(cur[k])) cur[k] = []; });
  ['products', 'collections'].forEach(function (k) { if (!cur[k] || typeof cur[k] !== 'object') cur[k] = {}; });
  cur.last_active = t;
  function trim() {                                            // 2. caps: ≤30 visits, ≤300 pages in total (counts stay exact)
    if (st.visits.length > MAX_VISITS) st.visits = st.visits.slice(-MAX_VISITS);
    var total = 0;
    for (var i = st.visits.length - 1; i >= 0; i--) {
      var v = st.visits[i];
      if (v.pages.length > MAX_PAGES_VISIT) v.pages = v.pages.slice(-MAX_PAGES_VISIT);
      if (total + v.pages.length > MAX_PAGES_TOTAL) { var room = Math.max(0, MAX_PAGES_TOTAL - total); v.pages = room ? v.pages.slice(-room) : []; }
      total += v.pages.length;
    }
  }

  /* ---------- this page ---------- */
  var P = CFG.page || {};
  var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
  var entry = { at: nowIso(), path: location.pathname + (P.type === 'search' ? location.search : ''), title: (document.title || '').slice(0, 140),
    type: P.type || (meta.page && meta.page.pageType) || 'other', handle: P.handle || '', dwell_s: 0, scroll_pct: 0 };
  if (meta.product) {
    var mv = meta.product.variants && meta.product.variants[0];
    entry.product_id = meta.product.id; entry.variant_id = Number(params.get('variant')) || (mv && mv.id) || null;
    entry.price = mv ? mv.price / 100 : null; entry.currency = meta.currency || '';
    entry.title = P.title || entry.title;
  }
  var mode = consentMode();
  cur.pages_count = (cur.pages_count || 0) + 1;
  if (mode === 'full') {
    cur.pages.push(entry);
    if (entry.type === 'product' && entry.handle) {
      var pr = cur.products[entry.handle] || { handle: entry.handle, product_id: entry.product_id || null, title: P.title || '', views: 0, dwell_s: 0 };
      pr.views++; pr.last_at = entry.at; pr.price = entry.price; cur.products[entry.handle] = pr;
    }
    if (entry.type === 'collection' && entry.handle) cur.collections[entry.handle] = (cur.collections[entry.handle] || 0) + 1;
    if (entry.type === 'search' && params.get('q')) { cur.searches.push({ q: params.get('q').slice(0, 120), at: entry.at }); cur.searches = cur.searches.slice(-20); }
  }
  trim();
  save(KEY, st);
  function reload() { var s = load(KEY); if (s && s.v === 2 && s.vid === st.vid) { st = s; cur = st.visits[st.visits.length - 1] || cur; } return st; }

  /* ---------- 5. activity (enabled browsers only) ---------- */
  var actBuf = [];
  function actOn() { return !!st.enabled_at && mode === 'full' && !AUTOMATED && !!CFG.activity_endpoint; }
  function toInr(v, cur) {
    if (v == null || !cur || cur === 'INR' || CFG.shop_currency !== 'INR') return null;
    var c = window.Shopify && window.Shopify.currency, r = c && c.active === cur ? Number(c.rate) : NaN;
    return r > 0 ? Math.round(Number(v) / r) : null;
  }
  function emit(type, data) {
    if (!actOn()) return;
    if (data && data.total != null && data.currency && data.currency !== 'INR' && data.total_inr == null) { var ti = toInr(data.total, data.currency); if (ti != null) data.total_inr = ti; }
    var e = { t: type, at: nowIso(), sid: cur.sid, path: location.pathname };
    for (var k in (data || {})) e[k] = data[k];
    actBuf.push(e);
    if (actBuf.length >= ACT_MAX_EVENTS) flushActivity(false);
  }
  function actQueue() { return load(AKEY) || { seq: 0, batches: [] }; }
  function makeBatch() {
    if (!actBuf.length) return null;
    var q = actQueue(); q.seq = (q.seq || 0) + 1;
    var b = { schema: 'dzyn.wa_activity.v1', batch_id: st.vid + ':' + q.seq, vid: st.vid, codes: st.codes.slice(-10), sent_at: nowIso(),
      is_preview: !!CFG.preview, shop: CFG.shop || '', events: actBuf.splice(0, ACT_MAX_EVENTS) };
    if (CFG.customer && CFG.customer.id) b.customer = { id: CFG.customer.id, email: CFG.customer.email || null, phone: CFG.customer.phone || null };
    q.batches.push({ id: b.batch_id, at: Date.now(), tries: 0, next: 0, body: JSON.stringify(b) });
    if (q.batches.length > 40) q.batches = q.batches.slice(-40);           // bounded: oldest unsent dropped
    save(AKEY, q);
    return b;
  }
  function flushActivity(leaving) {
    if (!actOn()) return;
    makeBatch();
    var q = actQueue(), nowT = Date.now();
    q.batches = q.batches.filter(function (x) { return nowT - x.at < 3 * 864e5 && x.tries < 8; });
    q.batches.forEach(function (x) {
      if (x.next > nowT && !leaving) return;
      if (leaving && x.beacon_at && nowT - x.beacon_at < 10000) return;   // visibilitychange + pagehide both fire on leave: beacon once
      x.tries++; x.next = nowT + Math.min(30 * 60 * 1000, 5000 * Math.pow(2, x.tries));   // back-off 10 s → 30 min
      if (leaving) {          // page leave: beacon (no ack) — kept queued and re-sent in 5 min as a safety net; the CRM dedupes by batch_id
        var queued = false;
        try { queued = navigator.sendBeacon(CFG.activity_endpoint, new Blob(['p=' + encodeURIComponent(x.body)], { type: 'application/x-www-form-urlencoded;charset=UTF-8' })); } catch (e) {}
        if (queued) { x.next = nowT + 5 * 60 * 1000; x.beacon_at = nowT; }
      } else {
        postTo(CFG.activity_endpoint, x.body, function (ok) { if (ok) { var q2 = actQueue(); q2.batches = q2.batches.filter(function (y) { return y.id !== x.id; }); save(AKEY, q2); } });
      }
    });
    save(AKEY, q);
  }
  setInterval(function () { flushActivity(false); }, ACT_EVERY);
  if (startedVisit) emit('visit_start', { landing: cur.landing, visit_no: st.visit_no });
  emit('page_view', { type: entry.type, handle: entry.handle, title: entry.title, product_id: entry.product_id || null,
    variant_id: entry.variant_id || null, price: entry.price == null ? null : entry.price, currency: entry.currency || '' });
  if (entry.type === 'search' && params.get('q')) emit('search', { q: params.get('q').slice(0, 120) });

  /* dwell (visible time only) + scroll depth for this page */
  var seenMedia = {};                                         // product-gallery slides actually shown on this page
  function imagesSeen() { return Object.keys(seenMedia).length; }
  document.addEventListener('carousel:settle', function (e) {
    if (e.target && e.target.closest && e.target.closest('product-gallery') && e.detail && e.detail.index != null) seenMedia[e.detail.index] = 1;
  }, true);
  var visibleSince = document.visibilityState === 'visible' ? Date.now() : 0, dwellMs = 0, maxScroll = 0;
  function dwellNow() { return Math.round((dwellMs + (visibleSince ? Date.now() - visibleSince : 0)) / 1000); }
  function flushPage() {
    reload();
    var last = cur.pages[cur.pages.length - 1];
    if (last && last.at === entry.at) { last.dwell_s = dwellNow(); last.scroll_pct = maxScroll; if (imagesSeen()) last.images_seen = imagesSeen(); }
    cur.last_active = Date.now(); save(KEY, st);
  }
  var leftSent = false;
  function onLeave() {
    flushPage();
    if (!leftSent) { emit('leave', { dwell_s: dwellNow(), scroll_pct: maxScroll, images_seen: imagesSeen() }); leftSent = true; }
    flushActivity(true);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { if (visibleSince) { dwellMs += Date.now() - visibleSince; visibleSince = 0; } onLeave(); }
    else { visibleSince = Date.now(); leftSent = false; }
  });
  window.addEventListener('pagehide', onLeave);
  var scrollTick = 0;
  window.addEventListener('scroll', function () {
    if (scrollTick) return;
    scrollTick = setTimeout(function () {
      scrollTick = 0;
      var h = document.documentElement.scrollHeight - innerHeight;
      var pct = h > 0 ? Math.min(100, Math.round((scrollY / h) * 100)) : 100;
      if (pct > maxScroll) maxScroll = pct;
    }, 250);
  }, { passive: true });

  /* ---------- cart ---------- */
  var lastCart = null;
  function slimItems(items) {
    return (items || []).slice(0, 30).map(function (i) {
      return { title: i.product_title || i.title, variant_title: i.variant_title, product_id: i.product_id, variant_id: i.variant_id || i.id,
        qty: i.quantity, price: (i.final_price != null ? i.final_price : i.price) / 100, url: i.url };
    });
  }
  function slimCart(c) { return c ? { item_count: c.item_count, total: c.total_price / 100, currency: c.currency, items: slimItems(c.items) } : null; }
  document.addEventListener('cart:change', function (e) {
    var d = e.detail || {};
    if (!d.cart) return;
    lastCart = d.cart;
    reload();
    var snap = { at: nowIso(), kind: d.baseEvent === 'variant:add' ? 'add' : 'change', item_count: d.cart.item_count, total: d.cart.total_price / 100, currency: d.cart.currency };
    if (mode === 'full') {
      if (snap.kind === 'add') {
        var added = slimItems(e.detail.items && e.detail.items.length ? e.detail.items : (d.cart.items || []).slice(0, 1));
        added.forEach(function (i) { cur.add_events.push({ at: snap.at, title: i.title, variant_id: i.variant_id, qty: i.qty, price: i.price }); });
        cur.add_events = cur.add_events.slice(-30);
        emit('add_to_cart', { items: added, item_count: snap.item_count, total: snap.total, currency: snap.currency });
      } else emit('cart', { item_count: snap.item_count, total: snap.total, currency: snap.currency, items: slimItems(d.cart.items) });
      cur.cart_events.push(snap); cur.cart_events = cur.cart_events.slice(-40);
    }
    save(KEY, st);
  });
  // which checkout opens: India = Shopflo (snippets/think27-shopflo.liquid, strict == 'IN'), everyone else = Shopify's own
  var FLO = ((CFG.geo && CFG.geo.shopify_country) || '') === 'IN';
  var lastMark = 0;
  function markCheckout(kind) {
    if (Date.now() - lastMark < 1500) return; lastMark = Date.now();
    reload(); if (!cur.checkout_started_at) cur.checkout_started_at = nowIso(); save(KEY, st);
    emit('checkout_start', { via: FLO ? 'shopflo' : 'shopify', kind: kind, item_count: lastCart ? lastCart.item_count : null,
      total: lastCart ? lastCart.total_price / 100 : null, currency: lastCart ? lastCart.currency : '' });
    flushActivity(true);
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('#flo-buy-now-button, .flo-buy-now-btn, .shopify-payment-button__button, .shopify-payment-button [role="button"]')) return markCheckout('buy_now');
    if (t.closest('a[href*="/checkout"], button[name="checkout"], [name="checkout"]')) markCheckout('cart');
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/checkout|\/cart$/.test(f.action) && e.submitter && e.submitter.name === 'checkout') markCheckout('cart');
  }, true);

  /* ---------- extra buying signals (CRM request 27-Sep): variant, media viewer, delivery check, checkout steps ---------- */
  function note(list, item, cap) {
    if (mode !== 'full') return;
    reload(); cur[list] = (cur[list] || []).concat([item]).slice(-(cap || 30)); save(KEY, st);
  }
  function tell(t, list, item, cap) {
    if (mode !== 'full') return;
    if (t !== 'checkout_step' && item.product_id == null && entry.product_id) item.product_id = entry.product_id;
    note(list, item, cap); emit(t, item);
  }
  // variant / colour / size change (Prestige fires variant:change on the product form; price is in paise)
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant; if (!v) return;
    var pv = e.detail.previousVariant;
    tell('variant_change', 'variant_changes', { at: nowIso(), kind: 'variant', handle: entry.handle, variant_id: v.id, variant_title: String(v.title || '').slice(0, 80),
      options: (v.options || []).slice(0, 3), price: v.price != null ? v.price / 100 : null, available: v.available !== false, previous_variant_id: pv ? pv.id : null });
  });
  // DZYN sells each colour / size as its own product, linked by the "product family" rail (snippets/think27-pdp-family.liquid)
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[class*="think27-famitem-"]'); if (!a) return;
    var lab = a.querySelector('[class*="think27-famlabel-"]'), to = '';
    try { to = (new URL(a.href).pathname.split('/products/')[1] || '').split('/')[0]; } catch (x) {}
    tell('variant_change', 'variant_changes', { at: nowIso(), kind: 'family', handle: entry.handle, to_handle: to.slice(0, 120),
      label: lab ? lab.textContent.replace(/\s+/g, ' ').trim().slice(0, 60) : '' });
  }, true);
  // image zoom / video / 3D / AR / 360 viewer opened
  var lastMedia = {};
  function mediaOpen(kind, index) {
    if (lastMedia[kind] && Date.now() - lastMedia[kind] < 2000) return; lastMedia[kind] = Date.now();
    tell('media_open', 'media_opens', { at: nowIso(), kind: kind, handle: entry.handle, index: index == null ? null : index });
  }
  document.addEventListener('lightbox:open', function (e) { mediaOpen('zoom', e.detail && e.detail.index); }, true);
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('.product-gallery__zoom-button') || (t.closest('product-gallery[allow-zoom]') && t.closest('img'))) return mediaOpen('zoom');
    if (t.closest('[data-t27-media="360"]')) return mediaOpen('360');
    if (t.closest('[data-shopify-xr]')) return mediaOpen('ar');
  }, true);
  document.addEventListener('play', function (e) { if (e.target && e.target.closest && e.target.closest('product-gallery')) mediaOpen('video'); }, true);
  document.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('model-viewer')) mediaOpen('3d'); }, true);
  // delivery / pincode check: Prestige's cart estimator today; any future widget (pincode checker, 360 viewer) just fires
  //   document.dispatchEvent(new CustomEvent('t27:track', { detail: { t: 'delivery_check', pincode: '110075', result: 'ok', days: 5, source: 'pdp' } }))
  function pin(v) { v = String(v || '').replace(/\s/g, ''); return /^[A-Za-z0-9-]{3,10}$/.test(v) ? v : ''; }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('shipping-estimator button');
    if (!b) return;
    var z = b.closest('shipping-estimator').querySelector('[name="address[zip]"]');
    if (z && pin(z.value)) tell('delivery_check', 'delivery_checks', { at: nowIso(), pincode: pin(z.value), source: 'cart_estimator' });
  }, true);
  var TRACK = { delivery_check: 'delivery_checks', media_open: 'media_opens' };
  document.addEventListener('t27:track', function (e) {
    var d = e.detail || {}; if (!TRACK[d.t]) return;
    if (d.t === 'media_open') return mediaOpen(String(d.kind || 'other').slice(0, 20), d.index);
    var item = { at: nowIso(), handle: entry.handle };
    for (var k in d) if (k !== 't' && d[k] != null && typeof d[k] !== 'object') item[k] = k === 'pincode' ? pin(d[k]) : String(d[k]).slice(0, 80);
    tell(d.t, TRACK[d.t], item);
  });
  // Shopflo checkout steps (India): its checkout iframe posts {type:'analytics', payload:{name,...}} to this page.
  //   Names from Shopflo's bundle: InitiateCheckout, PincodeSubmitted, AddresssSelected (sic), PaymentMethodSelected, PaymentCompleted.
  //   Only safe fields are kept: never the phone, e-mail or address.
  var FLO_STEP = { InitiateCheckout: 'started', PincodeSubmitted: 'pincode', AddresssSelected: 'address', AddressSelected: 'address',
    PaymentMethodSelected: 'payment_method', AddPaymentInfo: 'payment_method', PaymentCompleted: 'completed', Purchase: 'completed' };
  var floSeen = {};
  window.addEventListener('message', function (e) {
    if (e.origin !== 'https://checkout.shopflo.co' || !e.data || typeof e.data !== 'object') return;
    var d = e.data, p = (d.payload && typeof d.payload === 'object') ? d.payload : {};
    var step = d.type === 'analytics' ? FLO_STEP[p.name] : (d.type === 'CLOSE_IFRAME' || d.type === 'CLOSE_IFRAME_BUYNOW') ? 'closed' : null;
    if (!step) return;
    var key = step + ':' + (p.eventID || p.checkoutId || '');
    if (floSeen[key] && Date.now() - floSeen[key] < 3000) return; floSeen[key] = Date.now();
    var item = { at: nowIso(), via: 'shopflo', step: step, checkout_id: p.checkoutId ? String(p.checkoutId).slice(0, 64) : null,
      total: p.orderTotal != null && !isNaN(p.orderTotal) ? Number(p.orderTotal) : null, currency: typeof p.currency === 'string' ? p.currency : '',
      items: Array.isArray(p.lineItems) ? p.lineItems.length : null };
    if (step === 'pincode') { var z = p.pincode || p.zip || p.postalCode || (p.address && (p.address.zip || p.address.pincode)); if (pin(z)) item.pincode = pin(z); }
    if (step === 'payment_method') { var m = p.paymentMethod || p.payment_method || p.paymentMode || p.method; if (typeof m === 'string') item.method = m.slice(0, 40); }
    var od = step === 'completed' && p.shopifyOrderData && typeof p.shopifyOrderData === 'object' ? p.shopifyOrderData : null;
    if (od && od.name) item.order_name = String(od.name).slice(0, 20);
    tell('checkout_step', 'checkout_steps', item, 40);
    if (od && actOn() && actBuf.length && actBuf[actBuf.length - 1].step === 'completed') {
      var em = od.customer && od.customer.email, ph = od.phone || (od.customer && od.customer.phone);
      if (em || ph) actBuf[actBuf.length - 1].identity = { email: em ? String(em).slice(0, 120) : null, phone: ph ? String(ph).slice(0, 20) : null,
        customer_id: od.customer && od.customer.id ? String(od.customer.id).replace(/\D/g, '') : null, checkout_token: item.checkout_id, source: 'order' };
    }
    if (step === 'completed' || step === 'closed') flushActivity(false);
  });
  function fetchCart() {
    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { lastCart = c; return c; }).catch(function () { return lastCart; });
  }

  /* ---------- device ---------- */
  function device() {
    var ua = navigator.userAgent || '';
    var os = /Android/.test(ua) ? 'Android' : /iPhone|iPad|iPod/.test(ua) ? 'iOS' : /Windows/.test(ua) ? 'Windows' : /Mac OS X/.test(ua) ? 'macOS' : /Linux/.test(ua) ? 'Linux' : 'other';
    var br = /Edg\//.test(ua) ? 'Edge' : /SamsungBrowser/.test(ua) ? 'Samsung Internet' : /FBAN|FBAV|Instagram/.test(ua) ? 'In-app (Meta)' : /CriOS|Chrome\//.test(ua) ? 'Chrome' : /FxiOS|Firefox\//.test(ua) ? 'Firefox' : /Safari\//.test(ua) ? 'Safari' : 'other';
    var c = navigator.connection || {};
    return { ua: ua.slice(0, 300), mobile: /Mobi|Android|iPhone/.test(ua), os: os, browser: br, screen: screen.width + 'x' + screen.height,
      viewport: innerWidth + 'x' + innerHeight, dpr: Math.round((window.devicePixelRatio || 1) * 100) / 100,
      touch: 'ontouchstart' in window || navigator.maxTouchPoints > 0, connection: c.effectiveType || '', automated: !!navigator.webdriver };
  }

  /* ---------- WhatsApp links ---------- */
  var WA_RE = /^(https?:\/\/(wa\.me|api\.whatsapp\.com\/send|web\.whatsapp\.com\/send|chat\.whatsapp\.com)|whatsapp:\/\/send)/i;
  function shortPage() { return (location.host.replace(/^www\./, '') + location.pathname).replace(/\/$/, ''); }
  function parseWa(href) {
    var u; try { u = new URL(href, location.href); } catch (e) { return null; }
    if (/chat\.whatsapp\.com/i.test(u.hostname)) return null;           // group invite links: leave alone
    var num = u.searchParams.get('phone') || '';
    if (/wa\.me$/i.test(u.hostname)) num = u.pathname.replace(/\D/g, '') || num;
    return { number: (num || CFG.number || '').replace(/\D/g, ''), text: u.searchParams.get('text') || '' };
  }
  function areaOf(a) {
    var s = a.closest('[id^="shopify-section-"]');
    var id = s ? s.id.replace('shopify-section-', '') : '';
    if (a.closest('.think27-abar, announcement-bar, [class*="announcement"]')) return 'announcement-bar';
    if (a.closest('header-sidebar, #sidebar-menu')) return 'mobile-drawer';
    if (a.closest('header, .header')) return 'header';
    if (a.closest('footer, [class*="footer"]')) return 'footer';
    return id || 'page';
  }
  function visitView(v, withPages) {                    // one visit, as the CRM reads it (v1 shapes kept)
    var pv = [], cols = [], k;
    for (k in (v.products || {})) pv.push(v.products[k]);
    (v.pages || []).forEach(function (p) { if (p.type === 'product') for (var i = 0; i < pv.length; i++) if (pv[i].handle === p.handle) pv[i]._d = (pv[i]._d || 0) + (p.dwell_s || 0); });
    pv = pv.map(function (p) { var o = {}; for (var x in p) if (x !== '_d') o[x] = p[x]; o.dwell_s = p._d || p.dwell_s || 0; return o; });
    for (k in (v.collections || {})) cols.push({ handle: k, views: v.collections[k] });
    var started = v.started ? Date.parse(v.started) : Date.now();
    var out = { sid: v.sid, started: v.started, last_active: v.last_active ? new Date(v.last_active).toISOString() : null,
      duration_s: Math.max(0, Math.round(((v.last_active || Date.now()) - started) / 1000)), pages_count: v.pages_count || (v.pages || []).length,
      landing: v.landing || null, products_viewed: pv, collections_viewed: cols, searches: v.searches || [], add_events: v.add_events || [],
      cart_events: v.cart_events || [], checkout_started_at: v.checkout_started_at || null, wa_clicks: v.wa_clicks || [],
      variant_changes: v.variant_changes || [], media_opens: v.media_opens || [], delivery_checks: v.delivery_checks || [], checkout_steps: v.checkout_steps || [] };
    if (withPages) out.journey = v.pages || [];
    return out;
  }
  function buildPayload(code, a, before, visible, number, cart) {
    reload();
    var j = (cur.pages || []).slice();
    var last = j[j.length - 1];
    if (last && last.at === entry.at) { last = Object.assign({}, last, { dwell_s: dwellNow(), scroll_pct: maxScroll }); j[j.length - 1] = last; }
    var now = visitView(cur, false);
    var sc = slimCart(cart);
    // 3. the WHOLE stored history (older visits); trimmed so the form body stays under the CRM's 96 KB door
    var older = st.visits.slice(0, -1).map(function (v) { return visitView(v, true); });
    var payload = {
      schema: 'dzyn.wa_session.v1', code: code, sent_at: nowIso(), is_preview: !!CFG.preview,
      shop: CFG.shop || '', theme_id: CFG.theme_id || null,
      click: { at: nowIso(), page_url: location.href, page_short: shortPage(), page_type: entry.type,
        button: { text: (a.innerText || a.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 80), area: areaOf(a), href_before: before.slice(0, 400) },
        wa_number: number, message_visible: visible },
      visitor: { vid: st.vid, first_seen: st.first_seen, visit_no: st.visit_no || 1, sessions_before: Math.max(0, (st.visit_no || 1) - 1),
        enabled: true, enabled_at: st.enabled_at || nowIso(), codes: (st.codes.indexOf(code) < 0 ? st.codes.concat([code]) : st.codes).slice(-10), customer: CFG.customer || null },
      session: { sid: cur.sid, started: cur.started, duration_s: now.duration_s, pages_count: now.pages_count, landing: cur.landing || null, first_touch: st.first_touch || null },
      journey: j, products_viewed: now.products_viewed, collections_viewed: now.collections_viewed, searches: now.searches,
      signals: { variant_changes: now.variant_changes, media_opens: now.media_opens, delivery_checks: now.delivery_checks, checkout_steps: now.checkout_steps },
      cart: sc ? Object.assign(sc, { add_events: now.add_events, checkout_started_at: now.checkout_started_at })
               : { item_count: 0, total: 0, currency: (CFG.geo && CFG.geo.currency) || '', items: [], add_events: now.add_events, checkout_started_at: now.checkout_started_at },
      history: { visits_total: st.visit_no || 1, pages_total: st.visits.reduce(function (n, v) { return n + (v.pages_count || 0); }, 0), visits: older },
      geo: Object.assign({}, CFG.geo || {}, { timezone: (Intl.DateTimeFormat().resolvedOptions().timeZone || ''), browser_languages: (navigator.languages || [navigator.language]).slice(0, 5) }),
      device: device(),
      consent: { analytics: mode === 'full', mode: mode }
    };
    var body = JSON.stringify(payload);
    // over size: first drop the page lists of the oldest visits (their summaries stay), then whole oldest visits
    var hv = payload.history.visits, cut = 0;
    while (encodeURIComponent(body).length > 90000 && cut < hv.length) {
      if (hv[cut].journey && hv[cut].journey.length) { hv[cut].journey = []; hv[cut].journey_trimmed = true; payload.history.pages_trimmed = true; body = JSON.stringify(payload); }
      cut++;
    }
    while (encodeURIComponent(body).length > 90000 && payload.history.visits.length) {
      payload.history.visits.shift();                                        // oldest first; counts stay in visits_total
      payload.history.trimmed = (payload.history.trimmed || 0) + 1;
      body = JSON.stringify(payload);
    }
    while (encodeURIComponent(body).length > 90000 && payload.journey.length > 5) { payload.journey = payload.journey.slice(-Math.floor(payload.journey.length / 2)); body = JSON.stringify(payload); }
    return body;
  }

  /* Body = application/x-www-form-urlencoded  p=<JSON>  — a CORS-safelisted type, so the browser sends NO preflight
     (v4 seals OPTIONS on /hook). The CRM answers {ok:true} with Access-Control-Allow-Origin, so we can read the ack and
     stop retrying; if the answer cannot be read (endpoint not live yet / blocked), the queue retries on later pages. */
  function postTo(url, body, cb) {
    var form = 'p=' + encodeURIComponent(body);
    try {
      fetch(url, { method: 'POST', body: form, keepalive: form.length < 60000, mode: 'cors', credentials: 'omit',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { cb(!!(j && j.ok)); }, function () { cb(false); });
    } catch (e) {
      try { navigator.sendBeacon && navigator.sendBeacon(url, new Blob([form], { type: 'application/x-www-form-urlencoded;charset=UTF-8' })); } catch (x) {}
      cb(false);
    }
  }
  function post(body, cb) { postTo(CFG.endpoint, body, cb); }
  function queue(code, body) {
    var q = load(PKEY) || [];
    q = q.filter(function (x) { return x.code !== code && Date.now() - x.at < 3 * 864e5 && x.tries < 5; });
    q.push({ code: code, at: Date.now(), tries: 1, body: body });
    if (q.length > 10) q = q.slice(-10);
    save(PKEY, q);
  }
  function unqueue(code) { save(PKEY, (load(PKEY) || []).filter(function (x) { return x.code !== code; })); }
  function retryPending() {
    var q = load(PKEY) || [];
    q = q.filter(function (x) { return Date.now() - x.at < 3 * 864e5 && x.tries < 5; });
    save(PKEY, q);
    q.forEach(function (x) {
      x.tries++; save(PKEY, q);
      post(x.body, function (ok) { if (ok) unqueue(x.code); });
    });
  }
  setTimeout(retryPending, 2500);

  function handle(e) {
    if (e.defaultPrevented && e.type === 'click') return;
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a || !WA_RE.test(a.getAttribute('href') || '')) return;
    if (a.dataset.t27wsDone && Date.now() - Number(a.dataset.t27wsDone) < 1500) return;   // double-fire guard
    var before = a.href, w = parseWa(before);
    if (!w || !w.number) return;
    var visible = strip(w.text).trim() || (CFG.default_message || 'Hi DZYN, I would like some help. I am looking at [page]');
    visible = visible.replace(/\[page\]/g, shortPage());
    var code = randomCode();
    var msg = embed(visible, code);
    if (CFG.visible_ref) msg += ' (Ref ' + code + ')';
    a.href = 'https://api.whatsapp.com/send?phone=' + w.number + '&text=' + encodeURIComponent(msg);
    a.dataset.t27wsDone = String(Date.now());
    reload();
    // 4. this browser is now "enabled": its activity follows the customer from here on
    if (!st.enabled_at) st.enabled_at = nowIso();
    if (st.codes.indexOf(code) < 0) st.codes.push(code);
    st.codes = st.codes.slice(-20);
    cur.wa_clicks = (cur.wa_clicks || []).concat([{ at: nowIso(), code: code, page: shortPage() }]).slice(-20);
    save(KEY, st);
    var body = buildPayload(code, a, before, visible, w.number, lastCart);
    queue(code, body);
    post(body, function (ok) { if (ok) unqueue(code); });
    emit('wa_tap', { code: code, area: areaOf(a) });
    if (!lastCart) fetchCart();
    window.__t27wsLast = { code: code, href: a.href };   // test hook (read-only)
  }
  document.addEventListener('click', handle, true);
  document.addEventListener('auxclick', handle, true);
  fetchCart();
  retryActivitySoon();
  function retryActivitySoon() { setTimeout(function () { flushActivity(false); }, 3000); }
})();
